import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import JobsLayout from './JobsLayout';
import PostJob from './post/index';
import JobList from './list/index';
import CandidateList from './candidates/index';

const Jobs: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<JobsLayout />}>
                <Route index element={<Navigate to="post" replace />} />
                <Route path="post" element={<PostJob />} />
                <Route path="list" element={<JobList />} />
                <Route path="candidates" element={<CandidateList />} />
            </Route>
        </Routes>
    );
};

export default Jobs;
